module.exports = __webpack_public_path__ + "img/sketch_v01.a31da57c.jpg";